import { FormDocument } from './form-document.type';
import { VendorLibrary } from './vendor-library.type';

export interface ComponentDocument extends FormDocument {
  name?: string;
  componentType?: string;
  vendorLibrariesRel?: [VendorLibrary?];
  vendorLibrariesRelDev?: [VendorLibrary?];
}